import { put, call, fork, take } from 'redux-saga/effects';
import FileDownload from 'js-file-download';
import { REQUEST } from 'redux-config/reduxHelpers';
import { acceptError } from 'common/_redux';
import * as api from '../api';
import * as ActionTypes from './actions';

export function* getUserTagLogsSaga({ search }) {
  try {
    const { status, data } = yield call(api.getUserTagLogs, search);
    if (status < 300) {
      yield put(ActionTypes.getUserTagLogs.success(data));
    } else {
      yield put(ActionTypes.getUserTagLogs.failure(data.detail));
    }
  } catch (error) {
    yield put(acceptError(error, true));
    yield put(ActionTypes.getUserTagLogs.failure(error));
  }
}

export function* getUserTagLogsWatcherSaga() {
  while (true) {
    const { search } = yield take(ActionTypes.GET_USER_TAG_LOGS[REQUEST]);
    yield call(getUserTagLogsSaga, { search });
  }
}

export function* getUserTagLogFiltersSaga() {
  try {
    const { status, data } = yield call(api.getUserTagLogFilters);
    if (status < 300) {
      yield put(ActionTypes.getUserTagLogFilters.success(data));
    } else {
      yield put(ActionTypes.getUserTagLogFilters.failure(data.detail));
    }
  } catch (error) {
    yield put(acceptError(error, true));
    yield put(ActionTypes.getUserTagLogFilters.failure(error));
  }
}

export function* getUserTagLogFiltersWatcherSaga() {
  while (true) {
    yield take(ActionTypes.GET_USER_TAG_LOG_FILTERS[REQUEST]);
    yield call(getUserTagLogFiltersSaga);
  }
}

export function* exportUserTagLogsSaga({ search }) {
  try {
    const { status, data } = yield call(api.exportUserTagLogs, search);
    if (status < 300) {
      FileDownload(data, 'user_tag_logs.csv');
      yield put(ActionTypes.exportUserTagLogs.success(data));
    } else {
      yield put(ActionTypes.exportUserTagLogs.failure(data.detail));
    }
  } catch (error) {
    yield put(acceptError(error, true));
    yield put(ActionTypes.exportUserTagLogs.failure(error));
  }
}

export function* exportUserTagLogsWatcherSaga() {
  while (true) {
    const { search } = yield take(ActionTypes.EXPORT_USER_TAG_LOGS[REQUEST]);
    yield call(exportUserTagLogsSaga, { search });
  }
}

export default [
  fork(getUserTagLogsWatcherSaga),
  fork(getUserTagLogFiltersWatcherSaga),
  fork(exportUserTagLogsWatcherSaga),
];
